/** Whether a city/concert has a real place on the map. Pseudo-cities with no location — "Internet"
 *  for streamed and virtual concerts (country ZZ) — are stored at exactly 0,0, Null Island in the Gulf
 *  of Guinea; "Show on map" used to fly readers out to sea for them (ISSUES #075). */
export function hasMapLocation(p: { lat?: number | null; lon?: number | null }): boolean {
  return p.lat != null && p.lon != null && (p.lat !== 0 || p.lon !== 0);
}

/** Haversine distance between two points in kilometers. */
export function haversineKm(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function toRad(deg: number): number {
  return (deg * Math.PI) / 180;
}
